<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <modal size="large"
           v-show="show"
           id="ModalConfirmationCommission">

        <template v-slot:header>
            <h3 class="title">Solicitação de Faturamento</h3>
        </template>

        <template v-slot:body>
            <div class="container">
                <div class="form-row">
                    <div class="col-12 form-group">
                        <label for="propBillingFilterEmails">E-mails</label>
                        <SelectX
                                input-id="propBillingFilterEmails"
                                placeholder="Informe os e-mails"
                                allow-include-new="true"
                                v-model="emails"
                                :data-source="emailsSuggested"
                        />
                        <small>Selecione o(s) e-mail(s) desejado(s) e dê um "Enter" ou selecione com o mouse.</small>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12 t-r">
                        <span class="btn-group btn-group-sm">
                            <button type="button"
                                    :disabled="sending"
                                    @click="$emit('onClose')"
                                    class="btn btn-sm btn-dark">
                                <svg-icon icon="times"/>
                                Fechar
                            </button>
                            <button type="button"
                                    :disabled="sending || emails.length === 0"
                                    @click="sendEmail"
                                    class="btn btn-sm btn-theme-1">
                                <svg-icon :icon="!sending ? 'envelope' : 'sync'"
                                          :svg-class="{'refresh rotate-1-seg': sending}"/> Enviar
                            </button>
                        </span>
                    </div>
                    <br/>
                    <br/>
                </div>
                <div class="form-row">
                    <div class="col-12">
                        <table class="table table-striped table-sm table-bordered">
                            <thead class="thead-dark thead-center">
                            <tr>
                                <th>NÚMERO</th>
                                <th>DATA</th>
                                <th>VENDEDOR</th>
                                <th>COMPRADOR</th>
                                <th>PRODUTO</th>
                                <th>FATURAR EM</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="p in proposals" :key="p.id">
                                <td class="t-c f-w-700">{{p.number}}</td>
                                <td class="t-c">{{p.created_at | formatDate}}</td>
                                <td class="ellipsis">{{p.group_seller.name}}</td>
                                <td class="ellipsis">{{p.group_buyer.name}}</td>
                                <td class="ellipsis" >{{p.product.name}}</td>
                                <td class="t-c f-w-700" >{{p.billing_date | formatDate}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button type="button"
                    :disabled="sending"
                    @click="$emit('onClose')"
                    class="btn btn-sm btn-dark">
                <svg-icon icon="times"/>
                Fechar
            </button>
        </template>
    </modal>
</template>

<script>
    import SelectX from "../../components/particles/SelectX";

    export default {
        name: "ModalPermissionBilling",
        components: {
            SelectX
        },
        props: {
            proposals: {
                type: Array,
                default: () => [],
                required: true
            },
            showModal: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                sending: false,
                emails: [],
                emailsSuggested: []
            }
        },
        methods: {
            getEmails() {
                this.emailsSuggested = [];
                this.$appHttp.get(`/v1/proposals/search/search_email_sellers?sellers_id[]=${this.proposals.map(p => p.seller.id).join(',')}`)
                    .then(({data: result}) => {
                        this.emailsSuggested = result.map(e => {return {id: e.email, label: e.email}});
                    })
                    .catch(console.error);
            },
            sendEmail() {
                this.sending = true;
                this.$appHttp.post('/v1/proposals/send_billing', {proposals_ids: this.proposals.map(p => p.id), emails: this.emails.map(e => e.label)})
                    .then(() => {
                        this.$snotify.info('E-mail enviado com sucesso!', this.$appStorage.getUser().name);
                    })
                    .catch(err => {
                        console.error('Fail send email', err);
                        this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar enviar solicitação de faturamento.'}), this.$appStorage.getUser().name);
                    })
                    .finally(() => this.sending = false);
            }
        },
        computed: {
            show() {
                if (this.showModal && this.proposals.length > 0) this.getEmails();
                return this.showModal
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
